import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function ViewEdits() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userEmail, setUserEmail] = useState('');
  const [images, setImages] = useState([]);
  const [newImageName, setNewImageName] = useState('');

  // This useEffect ensures that userEmail and images are fetched on component mount
  useEffect(() => {
    const email = sessionStorage.getItem('userEmail');
    setUserEmail(email);

    if (!email) {
      navigate('/signin');
      return;
    }

    // If there is a newly replaced image from the previous page, set it to state
    if (location.state && location.state.replacedImageName) {
      setNewImageName(location.state.replacedImageName);
    }

    // Fetch the images from the backend
    const fetchImages = async () => {
      try {
        const response = await fetch(`/api/imagees/${email}`);
        const data = await response.json();
        setImages(data);
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };

    fetchImages();
  }, [navigate, location.state]);

  // Function to replace an image
  const handleImageReplace = async (imageName, newImageBase64) => {
    const data = {
      userEmail,
      imageName,
      image: newImageBase64,
    };

    try {
      const response = await fetch('/api/replace-imagee', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.ok) {
        console.log(result.message); // Log success message

        // Re-fetch images to reflect the updated image
        const fetchImages = async () => {
          try {
            const response = await fetch(`/api/imagees/${userEmail}`);
            const data = await response.json();
            setImages(data);  // Update the images state with the latest images
          } catch (error) {
            console.error('Error fetching updated images:', error);
          }
        };

        fetchImages();  // Re-fetch after replacing image

        // Set the newly replaced image name in the state and navigate
        setNewImageName(imageName);
        navigate('/Viewss', { state: { replacedImageName: imageName } });
      } else {
        console.error(result.error); // Log error message
      }
    } catch (error) {
      console.error('Error replacing image:', error);
    }
  };

  // Function to append timestamp to avoid caching of old images
  const getImageUrl = (imageName) => {
    return `/flask_static/${userEmail}/Rosap/${imageName}?t=${new Date().getTime()}`;
  };

  // Navigate to the image display page with the clicked image's name
  const handleImageClick = (imageName) => {
    navigate('/Viewss', { state: { imageName, userEmail } });
  };

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div
      style={{
        padding: '20px',
        textAlign: 'center',
        background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)',
        minHeight: '100vh',
      }}
    >
      <h2 style={{ color: '#E11584' }}>View/Edit Page</h2>

      <p style={{ color: '#E11584', fontSize: '20px' }}>
        Signed in as: {userEmail}
      </p>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
          gap: '10px',
          marginTop: '10px',
        }}
      >
        {images.map((imageName) => (
          <div key={imageName} onClick={() => handleImageClick(imageName)}>
            <img
              src={getImageUrl(imageName)}  // Appending timestamp to the image URL
              alt={imageName}
              style={{
                width: '60px',
                height: '60px',
                borderRadius: '8px',
                cursor: 'pointer',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              }}
            />
          </div>
        ))}
      </div>

      {newImageName && (
        <div>
          <h3>Replaced Image:</h3>
          <img
            src={getImageUrl(newImageName)}  // Appending timestamp to replaced image URL
            alt={newImageName}
            style={{
              width: '100px',
              height: '100px',
              borderRadius: '8px',
              marginTop: '10px',
            }}
          />
        </div>
      )}

      <button
        onClick={handleBack}
        style={{
          backgroundColor: '#E11584',
          color: 'black',
          padding: '12px 25px',
          fontSize: '14px',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          margin: '15px',
        }}
      >
        Back
      </button>
    </div>
  );
}

export default ViewEdits;
